import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import { useConversation } from '../../contexts/conversation';
import { ActorType } from '../../enums/conversation';
import MessageBubble from '../MessageBubble';
import { WidgetProps } from './index.types';

type Data = {
    buttons: {
        dailogueFlowId?: string;
        dialogueId?: string;
        name: string;
    }[];
    text: string;
};

function ResolutionConfirmation({ isLastMessage, message, widgetData }: WidgetProps) {
    const { sendMessage } = useConversation();
    const { actor, createdAt } = message;
    const data = widgetData.parameters as Data;

    const selectOption = (button: Data['buttons'][0]) => {
        const messageParts = [
            {
                isPrivate: false,
                text: { content: button.name },
            },
        ];

        sendMessage({ messageParts, input: button });
    };

    const renderButtons = () => {
        if (!isLastMessage) return null;

        return (
            <div className='flex gap-10'>
                {data.buttons.map((item) => (
                    <Button
                        key={item.name}
                        className='!py-0 !min-h-0'
                        size='md'
                        variant='flat'
                        onClick={() => selectOption(item)}
                    >
                        {item.name}
                    </Button>
                ))}
            </div>
        );
    };

    if (actor.type === ActorType.USER) return null;

    return (
        <MessageBubble actor={actor} timestamp={createdAt}>
            <div className='flex gap-10'>
                <Typography variant='body-md'>{data.text}</Typography>
                {renderButtons()}
            </div>
        </MessageBubble>
    );
}

export default ResolutionConfirmation;
